export default {
  data: () => ({
    truncateTextThreshold: 20,
    isTooltipShown: false,
    name: undefined,
  }),
  created() {
    this.name = this.node?.data.name
  },
  methods: {
    truncateFieldName(fieldName) {
      if (this.isNotTruncated(fieldName)) {
        return fieldName;
      }

      return `${fieldName.slice(0, 9).trim()}...${fieldName.slice(-9).trim()}`;
    },
    isNotTruncated (text) {
      return !this.isTooltipShown && text.length < this.truncateTextThreshold
    },
  }
}
